import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Notification from 'app/components/Notification';
import Button from 'app/components/Button';
import Icon from 'app/components/Icon';
import { Colors } from 'app/utils/colors';

export default function NoSubscriptionNotification({
  userSubscriptions,
  checkoutUrl
}) {
  const intl = useIntl();

  const hasExpiredSubscriptions = userSubscriptions?.length > 0;

  return (
    <>
      <Notification
        header={intl.formatMessage({
          id: hasExpiredSubscriptions
            ? 'controlpanel.payment_methods.subscription.notification.expired.title'
            : 'controlpanel.payment_methods.subscription.notification.active.title'
        })}
        content={intl.formatMessage({
          id: hasExpiredSubscriptions
            ? 'controlpanel.payment_methods.subscription.notification.expired.subtitle'
            : 'controlpanel.payment_methods.subscription.notification.active.subtitle'
        })}
        variant="info"
        button={null}
      />
      <div className="bb-payment-methods-bigbuy-page__content__subscriptions__activate">
        <Button
          onClick={() => {
            window.location.href = checkoutUrl;
          }}
          text={intl.formatMessage({
            id: hasExpiredSubscriptions
              ? 'controlpanel.wholesaler_pack.button.reactivate'
              : 'controlpanel.pack.active.title'
          })}
          size="big"
          type="primary"
          icon={
            <Icon icon="cube" size="lg" swapOpacity color={Colors.bbGrey2} />
          }
        />
      </div>
    </>
  );
}

NoSubscriptionNotification.propTypes = {
  userSubscriptions: PropTypes.arrayOf(PropTypes.node).isRequired,
  checkoutUrl: PropTypes.string.isRequired
};
